<template>
  <div class="container-fluid">
    <PainelAcesso>
      <template #cabecalho >
        <div class="modal-title">
          <div class="d-flex justify-content-center ">
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12">
              <h5>
                <span class="textos text-secondary">Por uma advocacia<br> colaborativa.</span>
              </h5>
              <h6 class="mt-3">
                <span class="textos text-secondary">Para acessar, faça seu login:</span>
                <div class="avisoDanger mensagemAlerta">{{mensagemAlerta}}</div>
                <div v-if="flags.efetuandoLogin" class="divLoginSpinner mb-3">
                  <span class="avisoDanger">Por favor, aguarde...</span>
                  <b-spinner class="ml-2" variant="danger"></b-spinner>
                </div>
              </h6>
            </div>
          </div>
        </div>
      </template>
      <template #corpo>
        <form>
          <div v-show="flags.escritorioNaoLogado" class="avisoDanger text-left mb-2">{{erroValidacaoCampos.escritorio}}</div>
          <div class="form-row justify-content-center">
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 form-group">
              <label class="small text-secondary" for="inputEmail">Email</label>
              <input type="text" id="inputEmail" @keyup="eventoLoginTeclaEnter" class="form-control corBordaCampo placeholder" v-model="dadosFormulario.email" placeholder="E-mail...">
              <div class="avisoDanger mt-2">{{erroValidacaoCampos.email}}</div>
            </div>
          </div>
          <div class="form-row justify-content-center">
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 form-group">
              <label class="small text-secondary" for="inputSenha">Senha</label>
              <input :type="mostrarSenha ? 'email' : 'password'" class="form-control " id="password-field" v-model="dadosFormulario.senha" placeholder="Senha...">
              <span class="position-absolute icon-wrapper" style="top: 40px; right: 15px;">
                  <i :class="`fa ${mostrarSenha ? 'fa-eye-slash' : 'fa-eye'} cursor-pointer`" @click="alternarSenha"></i>
              </span>
              <div class="avisoDanger mt-2">{{erroValidacaoCampos.senha}}</div>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button variant="btn btn-verde btn-block col-xl-8 col-lg-8 col-md-12 col-sm-12" :disabled="flags.efetuandoLogin" @click="autenticar">Entrar</b-button>
          </div>
          <div class="mt-3 d-flex justify-content-center">
            <router-link class="linkOutroEscritorio textos" :to="{name: 'recuperar-senha'}" :disabled="flags.efetuandoLogin">Esqueci minha senha</router-link>
          </div>
          <div class=" d-flex justify-content-center">
            <span class="textos">Não possui uma conta?
              <router-link class="linkOutroEscritorio textos" :to="{name: 'signup'}" :disabled="flags.efetuandoLogin">Criar conta</router-link>
            </span>
          </div>
        </form>
      </template>
    </PainelAcesso>
  </div>
</template>

<script>
import Login from './js/loginLite.js'
export default Login
</script>

<style scoped>
@import "./scss/login.scss";
</style>
